fragment Condition on Condition {
    config {
        ... on ConditionConfigEntityFilter {
            filter {
                ...EntityFilterFieldConfig
            }
        }

        ... on ConditionConfigLink {
            links
        }
    }
    humanReadableObjectiveString
}

fragment EntityFilterFieldConfig on EntityFilterFieldConfig {
    fieldName
    fieldType
    ... on EntityFilterFieldConfigCurrency {
        currencyComparator
        currencyValue
        currencyCode
    }
    ... on EntityFilterFieldConfigRelationship {
        relationshipData
        relationshipAnyAll
    }
    ... on EntityFilterFieldConfigString {
        stringContains
    }
    ... on EntityFilterFieldConfigEnum {
        enumValue
    }
    ... on EntityFilterFieldConfigIsSet {
        isSetValue
    }
}
